import React, { useEffect } from "react";
import { useNavContext } from "../../context-api/nav-context";
import PageHeaderSmall from "../../components/PageHeaderSmall";
import BlogImage from "../../components/BlogImage";

const BoilerGuide = () => {
  const { closeNavbarMenu } = useNavContext();
  const title = "The Complete Boiler Buying Guide 2022";
  const imgOne =
    "https://res.cloudinary.com/duwmjod0j/image/upload/q_80/v1643277420/AquaHeat/blog%20images/worcester_kitchen2_xmianz.webp";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <PageHeaderSmall title={title} />
      <BlogImage img={imgOne} onMouseOver={closeNavbarMenu} />
      <section
        className="section-wrapper conditions_global"
        onMouseOver={closeNavbarMenu}
      >
        <div className="conditions_body">
          <h2 className="conditions_subtitle">
            Can your current boiler be repaired?
          </h2>
          <p className="conditions_paragraph">
            Getting left without heating or hot water is always less than ideal.
            Before jumping straight into getting a new boiler have you found Gas
            Safe boiler engineers that can try repair your current boiler first?
            At Aquaheat, our Gas Safe boiler engineers can help with all aspects
            of boiler repairs and maintenance, and we'll always try and fix your
            boiler problem first, however if we believe you might need a new
            boiler, we'll offer you the best price on a new boiler installation.
          </p>
          <p className="conditions_paragraph">
            Finding a company who specialise in boiler repairs means they can
            diagnose the issue, offer you an instant quote and, if you’re happy,
            carry out the repairs quickly and effectively there and then. A fast
            solution to getting your boiler back up and running effectively.
          </p>
          <p className="conditions_paragraph">
            Aquaheat offer a range of boiler services from our expert engineers
            that could keep your boiler running effectively without the need to
            buy a new one.
          </p>
          <h2 className="conditions_subtitle">
            How to pick the right company to supply and install your new boiler
          </h2>
          <p className="conditions_paragraph">
            Brand new boilers are up to 40% more efficient, saving you money on
            your heating bills and limiting the possibility of needing repairs.
            If your boiler can’t be repaired, you’ll want to be sure you find a
            reliable company to supply and install a new one. Aquaheat offer
            expert boiler installations in Leeds and the surrounding areas. We
            install a wide range of new boilers suited to the needs of your
            property, all of which are installed by our expert, Gas Safe
            registered boiler installation team. We install new boilers from a
            variety of suppliers, including Ideal, Worcester, Baxi, Vaillant and
            Viessmann. We also provide a range of combi, system and conventional
            heat only boilers, plus we install unvented hot water systems.
          </p>
          <p className="conditions_paragraph">
            If you think you need a new boiler, or you’d like your boiler
            inspecting to see if it should be repaired or replaced, then get in
            touch via our contact form. Our boiler installation and repair
            specialists are always happy to answer any questions you may have
            around updating your boiler. We’ll provide you with a free, no
            obligation quote along with expert advice on the best boiler
            installation for your home. We can replace broken boilers or update
            outdated boiler systems, bringing you up to date with a modern combi
            boiler. All our boiler prices include installation and up to a 10
            year warranty.
          </p>
          <p className="conditions_paragraph">
            We’ll install your new boiler in no time, and we’ll take away your
            old boiler for free. You may also be eligible for up to £150
            cashback on your old boiler! When you choose to buy a boiler you
            need to feel sure that you’re in safe hands so not only do we offer
            expert boiler installation services, but we also offer 24/7 boiler
            repair services should anything ever go wrong.
          </p>
          <h2 className="conditions_subtitle">
            Picking the right boiler finance option
          </h2>
          <p className="conditions_paragraph">
            It can be a worry thinking about how much a new boiler will cost
            you, that’s why Aquaheat offer great finance options and expert
            engineers that can talk you though all of our boiler finance plans
            and options.
          </p>
        </div>
      </section>
    </>
  );
};

export default BoilerGuide;
